/** Agency-assignable roles (order: Associate → Setter → Closer → Manager → Admin). */
export const AGENCY_ROLE_OPTIONS = [
  { value: 'associate', label: 'Associate' },
  { value: 'setter', label: 'Setter' },
  { value: 'closer', label: 'Closer' },
  { value: 'manager', label: 'Manager' },
  { value: 'admin', label: 'Admin' },
];

export const AGENCY_ROLE_VALUES = AGENCY_ROLE_OPTIONS.map((r) => r.value);

export function roleOptionLabel(role) {
  const match = AGENCY_ROLE_OPTIONS.find((r) => r.value === role);
  if (match) return match.label;
  if (!role) return '';
  return String(role).replace(/_/g, ' ');
}
